import React, { Component } from "react";
import {
  Container,
  Header,
  Icon,
  Grid,
  Button,
  Form,
  Input,
  Checkbox,
  Table
} from "semantic-ui-react";
import "./estimate.css";
import estimatePDFDownload from "../pdf/estimatePDFDownload";
import { hashHistory } from "react-router";

import moment from "moment";
import Image from "semantic-ui-react/dist/commonjs/elements/Image/Image";
class EstimatorSimple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editmode: props.editmode,
      estimate: {
        projmanager: null,
        status: "Not Approved",
        tja: "N/A",
        sow: "",
        sowNumber: null,
        description: "",
        poNumber: "",
        poItemNumber: "",
        creator: "",
        date: props.today,
        workOrderNbr: props.nextwon,
        program: "",
        scopeOfWorkSummary: "",
        scope: "",
        docs: "None",
        total: null
      }
    };
  }
  populateState() {
    if (
      this.props.currentinfo &&
      this.props.currentinfo.program &&
      this.state.estimate.creator === "" &&
      this.props.myinfo
    ) {
      let newestimate = {
        ...this.state.estimate,
        creator: this.props.myinfo.lastname + " " + this.props.myinfo.firstname,
        projmanager: this.props.currentinfo.pminfo.contactname,
        program: this.props.currentinfo.program.program
      };
      console.log("newestimate", newestimate);
      this.setState({
        estimate: newestimate
      });
    } else if (
      this.props.estimate &&
      !this.state.estimate.total &&
      this.props.approval
    ) {
      let estimate = this.props.estimate;
      this.setState({ estimate: estimate });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    this.populateState();
  }
  componentDidMount() {
    this.populateState();
  }

  geneditcheck() {
    if (this.props.approval || this.props.editmode) {
      return (
        <div>
          <Checkbox
            toggle
            onChange={() => this.props.changeModes()}
            checked={this.props.approval}
            label={this.props.approval ? "Approval" : "Modify"}
          />
          <Button
            icon
            primary
            id="printbtn"
            onClick={() => {
              estimatePDFDownload({
                ...this.state.estimate,
                billing: this.props.billing
              });
            }}
          >
            <Icon name="print" />
          </Button>
          {this.wodbutton()}
        </div>
      );
    }
  }
  wodbutton() {
    if (this.props.existing_estimate) {
      return (
        <Button
          size="small"
          onClick={() => hashHistory.push("/work-orders/" + this.props.estimate.workOrderNbr)}
          color="blue"
        >
          Work Order
          <Icon name="arrow right" />
        </Button>
      );
    }else{
      return (
        <Button
          size="small"
          onClick={() => this.props.delete_estimate()}
          color="red"
        >
          Delete Estimate
        </Button>
      );
    }
  }
  handlesavebtn() {
    if (this.props.create) {
      if (this.state.estimate.total) {
        return (
          <Button
            positive
            size="mini"
            onClick={() => {
              console.log("sending estimate", this.state.estimate);
              this.props.handlesave(this.state.estimate);
            }}
          >
            <Icon name="checkmark" /> Create Estimate
          </Button>
        );
      }
    } else if (this.props.editmode) {
      return (
        <Button
          positive
          size="mini"
          onClick={() => {
            this.props.handlesave(this.state.estimate);
            this.setState({
              estimate: { ...this.state.estimate, edfapprover: 0 }
            });
          }}
        >
          <Icon name="checkmark" />
          Update
        </Button>
      );
    } else if (this.props.approval) {
      return (
        <Button
          positive
          disabled={
            this.props.estimate.edfapprover || !this.props.myinfo.hradmin
          }
          size="mini"
          onClick={() => {
            this.props.handleapprove();
          }}
        >
          <Icon name="checkmark" />
          {this.props.estimate.edfapprover ? <Icon name="checkmark" /> : ""}
          {this.props.estimate.edfapprover
            ? "Approved by " + this.props.estimate.edfapprover
            : "Approve"}
        </Button>
      );
    }
  }

  handleEdit(param, value) {
    if (this.props.editmode || this.props.create) {
      let newEstimate = { ...this.state.estimate, [param]: value };
      this.setState({ estimate: newEstimate });
    }
  }
  render() {
    if (this.props.tminvparams) {
      return (
        <Grid>
          <Grid.Column width={10}>
            <Container id="simpleEstimate">
              <Image
                src={require("./custPrintLetterhead.png")}
                centered
                id="logotext"
              />
              <Header as="h3" textAlign="center">
                Statement of Work
              </Header>
              <Table structured compact>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell width={1} inline singleLine>
                      Written For:
                    </Table.Cell>
                    <Table.Cell width={6} textAlign="left">
                      <Input
                        autoHeight
                        transparent
                        fluid
                        size="small"
                        value={this.state.estimate.projmanager}
                        onChange={e =>
                          this.handleEdit("projmanager", e.target.value)
                        }
                      />
                    </Table.Cell>
                    <Table.Cell width={1}>Status:</Table.Cell>
                    <Table.Cell textAlign="left" width={6}>
                      <Input
                        transparent
                        size="small"
                        fluid
                        value={this.state.estimate.status}
                        onChange={e =>
                          this.handleEdit("status", e.target.value)
                        }
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell width={1} inline>
                      By:
                    </Table.Cell>
                    <Table.Cell width={6} textAlign="left">
                      <Input
                        transparent
                        fluid
                        size="small"
                        value={
                          this.props.employee
                            ? this.props.employee.firstname +
                              " " +
                              this.props.employee.lastname
                            : this.state.estimate.creator
                        }
                        onChange={e =>
                          this.handleEdit("writtenby", e.target.value)
                        }
                        labelPosition="left"
                      />
                    </Table.Cell>
                    <Table.Cell width={1}>Description:</Table.Cell>
                    <Table.Cell textAlign="left" width={6}>
                      <Input
                        transparent
                        fluid
                        size="small"
                        value={this.state.estimate.description}
                        onChange={e =>
                          this.handleEdit("description", e.target.value)
                        }
                        labelPosition="left"
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell width={1} inline>
                      Date:
                    </Table.Cell>
                    <Table.Cell width={6} textAlign="left">
                      <Input
                        transparent
                        fluid
                        size="small"
                        value={moment(this.state.estimate.createDate).format(
                          "MM/DD/YYYY"
                        )}
                        onChange={e => this.handleEdit("date", e.target.value)}
                        labelPosition="left"
                      />
                    </Table.Cell>
                    <Table.Cell width={1}>SoW #:</Table.Cell>
                    <Table.Cell textAlign="left" width={6}>
                      <Input
                        transparent
                        fluid
                        size="small"
                        value={this.state.estimate.sowNumber}
                        onChange={e =>
                          this.handleEdit("sowNumber", e.target.value)
                        }
                        labelPosition="left"
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell width={1} inline>
                      EDF #:
                    </Table.Cell>
                    <Table.Cell width={6} textAlign="left">
                      <Input
                        transparent
                        fluid
                        inline
                        size="small"
                        value={
                          this.props.estimate && this.props.estimate.edfapprover
                            ? this.props.estimate.workOrderNbr
                            : this.props.tminvparams.nextwonumber
                        }
                        labelPosition="left"
                      />
                    </Table.Cell>
                    <Table.Cell width={1}>PO #:</Table.Cell>
                    <Table.Cell textAlign="left" width={6}>
                      <Input
                        transparent
                        fluid
                        size="small"
                        value={this.state.estimate.poNumber}
                        onChange={e =>
                          this.handleEdit("poNumber", e.target.value)
                        }
                        labelPosition="left"
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell width={1} inline>
                      Project:
                    </Table.Cell>
                    <Table.Cell width={6} textAlign="left">
                      <Input
                        transparent
                        fluid
                        size="small"
                        value={this.state.estimate.program}
                        onChange={e =>
                          this.handleEdit("program", e.target.value)
                        }
                        labelPosition="left"
                      />
                    </Table.Cell>
                    <Table.Cell singleLine width={1}>
                      PO Item:
                    </Table.Cell>
                    <Table.Cell textAlign="left" width={6}>
                      <Input
                        transparent
                        fluid
                        size="small"
                        value={this.state.estimate.poItemNumber}
                        onChange={e =>
                          this.handleEdit("poItemNumber", e.target.value)
                        }
                        labelPosition="left"
                      />
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
              <Form>
                <Form.Group widths="equal">
                  <Form.Field
                    label="Scope Of Work:"
                    value={this.state.estimate.scopeOfWorkSummary}
                    onChange={e =>
                      this.handleEdit("scopeOfWorkSummary", e.target.value)
                    }
                    control="textarea"
                    rows="4"
                  />
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field
                    label="Standard Work Documents:"
                    value={this.state.estimate.standardWork}
                    onChange={e =>
                      this.handleEdit("standardWork", e.target.value)
                    }
                    control="textarea"
                    rows="1"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    label="Budget"
                    type="number"
                    value={this.state.estimate.total}
                    onChange={e => this.handleEdit("total", e.target.value)}
                    icon="dollar"
                    iconPosition="left"
                  />
                </Form.Group>
              </Form>

              {this.handlesavebtn()}
              {this.geneditcheck()}
            </Container>
          </Grid.Column>
        </Grid>
      );
    }
  }
}

export default EstimatorSimple;



// WEBPACK FOOTER //
// ./src/components/estimates/estimatorsimple.js